import React from 'react';
import { Modal, ModalBody } from "botbit-ui-components";
import { MDBBtn, MDBIcon } from 'mdbreact';
import { getTranslationFunction } from "../../config/translations/translate";
import { translations } from "../../config/translations/PaymentSuspensionModal";

const SUPPORT_EMAIL = 'soporte@rayapp.io';
const SUPPORT_WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=5491172657595';

/**
 * Bloqueo por falta de pago. Se muestra cuando OO suspendió alguna tienda de la company activa por
 * impago, y no se puede cerrar: la cuenta está bloqueada hasta que se regularice.
 *
 * Mira suspensionReason, no status: SUSPENDED también es lo que queda una tienda que el dueño pausó
 * a mano, y a ese no hay que acusarlo de una deuda que no tiene. El de "reactivalas" del
 * AuthenticatedRouter sigue cubriendo ese otro caso.
 *
 * No hay CTA de pago (D13): la pantalla de pago no existe, soporte lo regulariza a mano. Espeja al
 * DunningModal de online-ordering, sin sus etapas NOTICE/GRACE — necesitan datos de dunning que solo
 * tiene OO.
 */
const PaymentSuspensionModal = ({ isOpen }) => {
    const t = getTranslationFunction(translations);

    if (!isOpen) return null;

    return (
        <Modal id="payment-suspension-modal" hideOtherModals isOpen={isOpen} size="md">
            <ModalBody>
                <div className="text-center p-3">
                    <MDBIcon icon="exclamation-triangle" size="3x" className="mb-3 text-warning" />
                    <h4>{t("title")}</h4>
                    <p className="text-muted">{t("description")}</p>
                    <p className="mb-2">{t("contactPrompt")}</p>
                    <div className="d-flex flex-column flex-md-row justify-content-center">
                        <MDBBtn color="primary" size="sm" outline href={`mailto:${SUPPORT_EMAIL}`}>
                            <MDBIcon icon="envelope" className="mr-2" />{t("email")}
                        </MDBBtn>
                        <MDBBtn color="primary" size="sm" outline onClick={() => window.open(SUPPORT_WHATSAPP_URL, '_blank')}>
                            <MDBIcon fab icon="whatsapp" className="mr-2" />{t("whatsapp")}
                        </MDBBtn>
                        {/* Intercom se bootea siempre en este backoffice (AuthenticatedRouter), sin gate de ambiente. */}
                        <MDBBtn color="primary" size="sm" outline onClick={() => window.Intercom("show")}>
                            <MDBIcon icon="comments" className="mr-2" />{t("chat")}
                        </MDBBtn>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default PaymentSuspensionModal;
